import * as React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  EventConfigProps,
  EventConfigTypes,
  WidgetProps,
  ComponentProps,
} from '@intermix-dashboard/core';
import { useThemeObserver } from '../hooks/useThemeObserver';

export const IntermixPieChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
  dataTransform,
  eventConfig,
}) => {
  const inputRef = React.useRef<any>(null);
  const [renderData, setRenderData] = React.useState<any>(null);
  const { display } = useThemeObserver();
  React.useEffect(() => {
    if (typeof data.rows === 'undefined') return;
    if (dataTransform) {
      setRenderData(dataTransform(data, options));
    } else {
      setRenderData(data);
    }
  }, [data, options.title, dataTransform]);

  return (
    <div
      ref={inputRef}
      style={{ display: 'flex', width: '100%', flex: '1' }}
      id="intermix-card"
    >
      <>
        {renderData && display && (
          <Pie
            data={JSON.parse(JSON.stringify(renderData))}
            onElementsClick={(elems) => {
              if (
                elems &&
                elems.length > 0 &&
                typeof elems[0]._index !== 'undefined'
              ) {
                const nonZeroEvent = eventConfig?.find(
                  (item: EventConfigProps) =>
                    item.type === EventConfigTypes.NONZERO
                );
                const defaultEventConfig = eventConfig?.find(
                  (item: EventConfigProps) =>
                    item.type === EventConfigTypes.DEFAULT
                );
                if (nonZeroEvent) {
                  const event = new CustomEvent('intermix-event-non-zero', {
                    detail: {
                      key: elems[0]._model.label,
                    },
                    bubbles: true,
                    cancelable: false,
                    composed: true, // makes the event jump shadow DOM boundary); */
                  });
                  (inputRef.current as any).dispatchEvent(event);
                } else if (defaultEventConfig) {
                  const event = new CustomEvent('intermix-event', {
                    detail: {
                      key: defaultEventConfig.key,
                      value: elems[0]._model.label,
                    },
                    bubbles: true,
                    cancelable: false,
                    composed: true, // makes the event jump shadow DOM boundary); */
                  });
                  inputRef.current.dispatchEvent(event);
                }
              }
            }}
            options={{
              responsive: true,
              title: {
                display: true,
                text: options.title ? options.title : '',
              },
            }}
          />
        )}
      </>
    </div>
  );
};

export const IntermixPieChartWidget: WidgetProps = {
  id: 'analytics-widget',
  component: IntermixPieChartComponent,
};
